module.exports = __webpack_public_path__ + "img/placket length.67ca5e79.png";